import React from "react";
import * as Yup from "yup";
import { useFormikContext } from "formik";
import { FormGroup } from "../../../../components/form";
import ContextOfChildTable from "../../../../components/applicationComponents/legacy/contextOfChild/ContextOfChildTable";

export const contextOfChildFormLegacy: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "warning",
      },
      label: "Select the rating that best describes the child’s functioning and the support provided in each of the domains.",
    },
    {
      type: "component",
      body: ({ values }) => {
        const { errors } = useFormikContext();
        return (
          <div>
            <ContextOfChildTable values={values} errors={errors}></ContextOfChildTable>
          </div>
        );
      },
      defaultValue: {
        complexMedicalNeeds: null,
        physical: null,
        specialisedEquipment: null,
        fineMotor: null,
        communication: null,
        learning: null,
        social: null,
        selfCareSkills: null,
        behaviour: null,
      },
      validation: {
        complexMedicalNeeds: Yup.number().required("A response is required"),
        physical: Yup.number().required("A response is required"),
        specialisedEquipment: Yup.number().required("A response is required"),
        fineMotor: Yup.number().required("A response is required"),
        communication: Yup.number().required("A response is required"),
        learning: Yup.number().required("A response is required"),
        social: Yup.number().required("A response is required"),
        selfCareSkills: Yup.number().required("A response is required"),
        behaviour: Yup.number().required("A response is required"),
      },
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "fieldadv",
      },
      label: "Select N/A (not assessed) if the domain does not apply to the application or the application is ineligible",
    },
  ],
};
